<template>
  <div class="manufacturers-page pa-6 pa-md-10">
    <div class="d-flex align-center">
      <div class="text-h6 mb-1">{{ $t('manufacturer.title') }}</div>
      <v-spacer />
      <!-- Les types sont rangés dans leur constructeur ; la liste complète reste là (ceux d'une marque à rattacher). -->
      <v-btn small text :to="{name: 'charging-point-types'}"><v-icon small left>mdi-ev-station</v-icon>{{ $t('manufacturer.all-types') }}</v-btn>
    </div>
    <div class="text-caption text--secondary mb-4">{{ $t('manufacturer.hint') }}</div>
    <manufacturer-list />
  </div>
</template>

<script>
import ManufacturerList from "./ManufacturerList.vue";

/** Paramètres → Constructeurs : la liste des constructeurs de la plateforme (notion commune, pas seulement firmware). */
export default {
  components: {ManufacturerList},
}
</script>
